import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-medium leading-5 transition-colors duration-150",
  {
    variants: {
      variant: {
        default: "border-border bg-surface-elevated text-muted-foreground",
        neutral: "border-border bg-surface-elevated text-muted-foreground",
        interactive: "border-accent bg-accent-soft text-accent",
        buy: "border-buy bg-buy-soft text-buy",
        sell: "border-sell bg-sell-soft text-sell",
        warning: "border-warning bg-warning-soft text-warning",
        destructive: "border-destructive bg-surface-elevated text-destructive",

        /* Compatibility aliases until current product call sites adopt StatusBadge. */
        score: "border-border bg-surface-elevated text-muted-foreground",
        muted: "border-border bg-surface-elevated text-muted-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
